module.exports = __webpack_public_path__ + "img/elicotteroWhite.578fd5a5.svg";